import { useInView } from "react-intersection-observer"
import * as styles from "./styles.module.scss"
import cx from "classnames"
import MediaPlayButton from "components/MediaPlayButton"
import * as React from "react"

export interface VideoBoxProps {
  id: string
  src: string
  poster: string
  preload?: string
}

const VideoBox: React.FC<VideoBoxProps> = ({ id, src, poster, preload }) => {
  const [ref, inView] = useInView()

  return (
    <div className={styles.videoBox}>
      <div
        className={cx({
          [styles.videoPlayer]: true,
          [styles.inView]: inView,
        })}
        ref={ref}
      >
        <div className={styles.circle} />
        <video
          className={styles.video}
          id={id}
          poster={poster}
          controlsList="nodownload"
          preload={preload || "metadata"}
        >
          <source src={src} />
        </video>
        <div
          className={cx({
            [styles.playTrigger]: true,
            [styles.overlay]: true,
          })}
        >
          <MediaPlayButton />
        </div>
      </div>
    </div>
  )
}

export default VideoBox
